import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, LanguagesIcon, PhoneIcon, StarIcon, WrenchIcon } from 'lucide-react';
import { business } from '../../data/business';
import { copy } from '../../data/copy';
import { useLanguage } from '../../contexts/LanguageContext';
import { Stars } from '../Stars';
const trustIcons = [StarIcon, WrenchIcon, ClockIcon, LanguagesIcon];
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="bg-navy-950" data-id="element-236" data-mp="amgxhheuk1ek">
      <div className="relative flex min-h-[60vh] w-full items-center overflow-hidden md:min-h-[80vh] lg:min-h-[calc(100vh-7.5rem)]" data-id="element-237" data-mp="5oxjmim29qn5">
        <img src={business.bannerUrl} alt="A&J Auto Repair technician reviewing diagnostic results on a tablet inside the service bay" className="absolute inset-0 h-full w-full object-cover object-[70%_center]" width={3840} height={2160} fetchPriority="high" data-id="element-238" data-mp="qw0xysjrtc7" />
        <div aria-hidden="true" className="absolute inset-0 bg-navy-950/80 md:bg-navy-950/70" data-id="element-239" data-mp="1q3hecqi0c7td" />

        <div className="relative mx-auto w-full max-w-7xl px-6 py-16 sm:py-20 lg:py-24" data-id="element-240" data-mp="1rv5n9y8y6zxs">
          <div className="max-w-2xl" data-id="element-241" data-mp="1cy6e45yg6z17">
            <p className="text-sm font-semibold uppercase tracking-[0.16em] text-gold-400" data-id="element-242" data-mp="1cz7w6udvslsf">
              {t(copy.hero.eyebrow)}
            </p>
            <h1 className="mt-5 font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl xl:text-7xl" data-id="element-243" data-mp="1hz2on2db1jfl">
              {t(copy.hero.headline1)}
              <br data-id="element-244" data-mp="2anzu24wf3lqx" />
              {t(copy.hero.headline2)}
              <span className="block text-gold-400" data-id="element-245" data-mp="1vvzfv4xc52x0">
                {t(copy.hero.headline3)}
              </span>
            </h1>
            <p className="mt-6 max-w-xl font-display text-lg font-medium leading-relaxed text-gold-200 sm:text-xl" data-id="element-246" data-mp="20uaqhhvgfhga">
              {t(copy.hero.tagline)}
            </p>
            <p className="mt-4 max-w-xl leading-relaxed text-navy-100" data-id="element-247" data-mp="2tdg7fst7b8or">
              {t(copy.hero.subheadline)}
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-248" data-mp="337ls6ud14kor">
              <Link to="/contact" className="flex min-h-[54px] items-center justify-center rounded-md bg-gold-500 px-8 font-bold text-navy-950 transition-colors duration-150 ease-smooth hover:bg-gold-400" data-id="element-249" data-mp="2yadasvzpgkok">
                {t(copy.cta.book)}
              </Link>
              <a href={business.phoneHref} className="flex min-h-[54px] items-center justify-center gap-2 rounded-md border border-white/40 bg-navy-950/40 px-8 font-bold text-white transition-colors duration-150 ease-smooth hover:bg-navy-950/70" data-id="element-250" data-mp="2kaauvfayk1by">
                <PhoneIcon width={18} height={18} aria-hidden="true" data-id="element-251" data-mp="26jfi3rxc9033" />
                {t(copy.cta.call)} {business.phoneDisplay}
              </a>
            </div>

            <div className="mt-8 flex items-center gap-3 text-navy-100" data-id="element-252" data-mp="1wk8370aygxdv">
              <Stars rating={business.rating} size={18} data-id="element-253" data-mp="1wmaudnnugwk6" />
              <span className="text-sm" data-id="element-254" data-mp="c14ci4iogdsz">
                <span className="font-bold text-white" data-id="element-255" data-mp="c4a17ine9do6">{business.rating}</span>{' '}
                · {business.reviewCount} {t(copy.hero.ratingSuffix)}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-navy-900" data-id="element-256" data-mp="q271ap12427l">
        <ul className="mx-auto grid max-w-7xl gap-x-8 gap-y-6 px-6 py-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-257" data-mp="q0vwqmzseqff">
          {copy.trust.map((item, index) => {
          const Icon = trustIcons[index];
          return <li key={item.title.en} className="flex items-start gap-3" data-id="element-258" data-mp="3udixn3l48ydc" data-mpi={index}>
                <Icon width={20} height={20} aria-hidden="true" className="mt-0.5 shrink-0 text-gold-400" data-id="element-259" data-mp="2at8khyzu4m3" />
                <span data-id="element-260" data-mp="36pszlz08ht85">
                  <span className="block font-bold text-white" data-id="element-261" data-mp="36ohxe3mfstj5">
                    {t(item.title)}
                  </span>
                  <span className="block text-sm text-navy-300" data-id="element-262" data-mp="2rmrm9dyw06jl">
                    {t(item.detail)}
                  </span>
                </span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}